/**
 * @author Arul Vivek
 */

import service from '../Common/'
import constants from '../../../settings/shared/constants'


function createMount(mountData) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer ' + jwtToken}
        return service({
            url: constants.api.additionalMount.createMount,
            method: 'POST',
            headers: headers,
            data:  mountData
        });
}

function getAllMountsByStorageFileId(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer ' + jwtToken}
        return service({
            url: constants.api.additionalMount.getMountByFileId + id,
            method: 'GET',
            headers: headers,
            data:  ''
        });
}

function UnmountBucket(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer ' + jwtToken}
        return service({
            url: constants.api.additionalMount.unMountStorage + id,
            method: 'DELETE',
            headers: headers,
            data:  ''
        });
}

//To export run function
const ExternalMountService = {
    createMount, getAllMountsByStorageFileId, UnmountBucket
}
export default ExternalMountService;